import { ComponentChildren, FunctionalComponent } from 'preact'
import { RefinementListProvided } from 'react-instantsearch-core'
import { connectRefinementList, Highlight } from 'react-instantsearch-dom'
import Phrase from '../../../libs/translationsUtils/phrase'

interface ListProps extends RefinementListProvided {
  title: ComponentChildren
}

const List: FunctionalComponent<ListProps> = ({ title, ...restProps }) => {
  return (
    <div className='instant-search-tags-filter'>
      <span className='instant-search__filter-title'>{title}</span>
      <ListContent {...restProps} />
    </div>
  )
}

const ListContent: FunctionalComponent<RefinementListProvided> = ({
  items,
  isFromSearch,
  refine,
  createURL
}) => {
  if (items.length === 0) {
    return (
      <div class='instant-search__filter-no-results'>
        <Phrase p='No results' m='Control' />
      </div>
    )
  }
  return (
    <ul className='public-tags list list--float'>
      {items.map((item) => (
        <a
          key={item.objectID}
          className={`tag--pill qa-tag-pill ${item.isRefined ? 'tag--active' : ''}`}
          href={createURL(item.value)}
          onClick={(event) => {
            event.preventDefault()
            refine(item.value)
          }}
        >
          {isFromSearch ? <Highlight attribute='label' hit={item} /> : item.label} ({item.count})
        </a>
      ))}
    </ul>
  )
}

export default connectRefinementList(List)
